import React from 'react'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'

export default function EditButton ({ profileEditPath }) {
  return (
    <div className='edit-profile-button'>
      <a href={profileEditPath} className='button editprofile'>
        {I18n.t('profiles.profile_layout.edit')}
      </a>
    </div>
  )
}

EditButton.propTypes = {
  profileEditPath: PropTypes.string
}
